export default "__VITE_ASSET__Dy86H_Px__"